import React from 'react';
import AlertService from '@app/model/alert/service/AlertService';
import { useQuery } from '@tanstack/react-query';
import { AlertQueryKeys } from '@app/model/alert/service/AlertQueryKeys';
import FormInPortletPlaceholder from '@app/component/placeholder/FormInPortletPlaceholder';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import CompanyHotelForm from '@app/site/secured/rateshopper/rates/settings/page/competitors/CompanyHotelForm';

const RateshopperCompetitorsSettingsPage = React.memo(() => {

	const { companyHotel } = useSelectedCompanyHotel();

	const { data: alertOutputs, isLoading, isSuccess } = useQuery({
		queryFn: async () => {
			return AlertService.findAlerts(companyHotel.id).then(data => {
				return Promise.resolve(!data ? [] : data);
			});
		},
		queryKey: AlertQueryKeys.list(companyHotel.id),
		initialData: () => [],
	});

	if (isLoading) return <main><FormInPortletPlaceholder /></main>;

	else if (isSuccess) {
		return <CompanyHotelForm companyHotel={companyHotel} hasAlerts={alertOutputs.length > 0} />;
	}
	return <></>;
});


export default RateshopperCompetitorsSettingsPage;